module.exports = __webpack_public_path__ + "img/RP_icon.94e65cf6.png";